import { useState, useEffect } from 'react';
import { Avatar } from '@mui/material';

const IMAGES_CDN_URL = import.meta.env.VITE_IMAGES_CDN_URL || 'https://images.agendario.com.br';

/**
 * Avatar que busca a imagem do serviço no bucket agendario-images (FileService)
 * Path: service/{serviceId}.jpg
 * Se não existir (404), exibe as iniciais.
 */
export default function ServiceAvatar({ serviceId, photoTimestamp, sx, children }) {
  const [imageError, setImageError] = useState(false);

  const photoUrl = serviceId
    ? `${IMAGES_CDN_URL}/service/${serviceId}.jpg${photoTimestamp ? `?v=${photoTimestamp}` : ''}`
    : null;

  // Reseta o erro quando a URL muda (ex: após upload de nova foto com novo timestamp)
  useEffect(() => {
    setImageError(false);
  }, [photoUrl]);

  const shouldShowImage = photoUrl && !imageError;

  return (
    <Avatar
      src={shouldShowImage ? photoUrl : undefined}
      imgProps={{ onError: () => setImageError(true) }}
      sx={sx}
    >
      {shouldShowImage ? null : children}
    </Avatar>
  );
}
